// extracted by mini-css-extract-plugin
module.exports = {"v-toolbar__items":"App_v-toolbar__items_12QCn","v-btn":"App_v-btn_36SSU","page-header":"App_page-header_2fgGT"};